import { COMMUNITY_COLORS } from "@/utils/graphAnalysis";

const normalizeColor = (value: string) => value.trim().toLowerCase();

export const getNodeColorSwatchClass = (color?: string | null): string => {
	if (!color) return "node-color-swatch color-default";

	const normalized = normalizeColor(color);
	const colorIndex = COMMUNITY_COLORS.findIndex((communityColor) => normalizeColor(communityColor) === normalized);

	if (colorIndex < 0) {
		return "node-color-swatch color-default";
	}

	return `node-color-swatch color-${colorIndex}`;
};

export default getNodeColorSwatchClass;
